module.exports = __webpack_public_path__ + "04_glasses_red.cd842269.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/04_glasses_red.png
// module id = zr1c
// module chunks = 0